var React = require('react');

function Filter (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":0}),React.createElement("path",{"d":"M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z","key":1})]);
}

Filter.defaultProps = {"height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Filter;

Filter.default = Filter;
